<template>
  <div class="w100 pt20 pb20 bg-w display-box subject topic-dl">
    <div class="module-items w120 mc pt20 pb20">
      <div class="centerDL">
        <div class="w100 font-24 tx-c dl-left">
          办事服务
          <span style="color: #98adc3; font-size: 12px">/Services</span>
        </div>
        <el-row style="display: flex; align-items: center">
          <el-col :span="24">
            <el-tabs v-model="activeValue" type="card" @tab-click="handleClick">
              <el-tab-pane
                v-for="(e, i) in titleData"
                :label="e.label"
                :key="i"
                :name="e.value"
              ></el-tab-pane>
            </el-tabs>
          </el-col>
        </el-row>
        <div class="dl-more" style="top: 0">
          <el-input v-model="servicesInput" placeholder="请输入内容" @keyup.enter.native="handleClick"
            ><el-button
              @click="handleClick"
              slot="append"
              icon="el-icon-search"
            ></el-button
          ></el-input>
        </div>
      </div>
      <div
        class="centCla"
        v-loading="tableLoading"
        :style="{ height: tableLoading ? '684px' : '' }"
      >
        <div class="centLf" v-if="activeValue != '4' && itemData1.length > 0">
          <div
            class="lfImg"
            :style="{
              'background-image': `url(${baseUrl}images/topic-dl1.png)`,
            }"
            style="background-size: 100%"
          >
            <div class="lfTitle">{{ itemData1[0].typeName || "" }}</div>
          </div>
          <div
            class="serve-item"
            v-for="(e, i) in itemData1.slice(0, 4)"
            :key="i"
            @click="goServe(e)"
          >
            <div class="itemTypeCla">
              {{ e.typeName.toString().substring(0, 5) }}
            </div>
            <div class="serve-logo">
              <img :src="e.serveLogo" alt="" />
            </div>
            <div class="serve-name ellipsis">{{ e.serveName }}</div>
            <div class="rateClass">
              <el-rate
                v-model="e.serveStar"
                disabled
                disabled-void-color="#a8aaaf"
                text-color="#ff9900"
              >
              </el-rate>
              <span>{{ e.serveCollect }}人收藏</span>
            </div>
          </div>
        </div>
        <div class="centLf" v-if="activeValue != '4' && itemData2.length > 0">
          <div
            class="lfImg"
            :style="{
              'background-image': `url(${baseUrl}images/topic-dl2.png)`,
            }"
            style="background-size: 100%"
          >
            <div class="lfTitle">{{ itemData2[0].typeName || "" }}</div>
          </div>
          <div
            class="serve-item"
            v-for="(e, i) in itemData2.slice(0, 4)"
            :key="i"
            @click="goServe(e)"
          >
            <div class="itemTypeCla">
              {{ e.typeName.toString().substring(0, 5) }}
            </div>
            <div class="serve-logo">
              <img :src="e.serveLogo" alt="" />
            </div>
            <div class="serve-name ellipsis">{{ e.serveName }}</div>
            <div class="rateClass">
              <el-rate
                v-model="e.serveStar"
                disabled
                disabled-void-color="#a8aaaf"
                text-color="#ff9900"
              >
              </el-rate>
              <span>{{ e.serveCollect }}人收藏</span>
            </div>
          </div>
        </div>
        <div class="centLf" v-if="activeValue != '4' && itemData3.length > 0">
          <div
            class="lfImg"
            :style="{
              'background-image': `url(${baseUrl}images/topic-dl3.png)`,
            }"
            style="background-size: 100%"
          >
            <div class="lfTitle">{{ itemData3[0].typeName || "" }}</div>
          </div>
          <div
            class="serve-item"
            v-for="(e, i) in itemData3.slice(0, 4)"
            :key="i"
            @click="goServe(e)"
          >
            <div class="itemTypeCla">
              {{ e.typeName.toString().substring(0, 5) }}
            </div>
            <div class="serve-logo">
              <img :src="e.serveLogo" alt="" />
            </div>
            <div class="serve-name ellipsis">{{ e.serveName }}</div>
            <div class="rateClass">
              <el-rate
                v-model="e.serveStar"
                disabled
                disabled-void-color="#a8aaaf"
                text-color="#ff9900"
              >
              </el-rate>
              <span>{{ e.serveCollect }}人收藏</span>
            </div>
          </div>
        </div>
        <div class="centLf" v-if="activeValue == '4'">
          <div
            class="serve-item"
            v-for="(e, i) in itemData4.slice(0, 14)"
            :key="i"
            @click="goServe(e)"
          >
            <div class="itemTypeCla">
              {{ e.typeName.toString().substring(0, 5) }}
            </div>
            <div class="serve-logo">
              <img :src="e.serveLogo" alt="" />
            </div>
            <div class="serve-name ellipsis">{{ e.serveName }}</div>
            <div class="rateClass">
              <el-rate
                v-model="e.serveStar"
                disabled
                disabled-void-color="#a8aaaf"
                text-color="#ff9900"
              >
              </el-rate>
              <span>{{ e.serveCollect }}人收藏</span>
            </div>
          </div>
        </div>
      </div>
      <div class="more" @click="goMore">查看更多</div>
    </div>
    <IframeView ref="IframeView"></IframeView>
    <queryTypeModal :data="dataModal" @close="onDialogClose" />
  </div>
</template>

<script>
import { getTopicDlList } from "@/api/managementCenter/specialManage";
import queryTypeModal from "@/components/common/queryTypeModal.vue";
import IframeView from "@/components/public/IframeView.vue";
import { bpmnStartProcess } from "@/api/bpmnApi/bpmn";
export default {
  name: "TOPICDL",
  components: { queryTypeModal, IframeView },
  props: ["moduleData"],
  data() {
    return {
      tableLoading: false,
      baseUrl: process.env.BASE_URL,
      activeValue: "2",
      titleData: [
        {
          value: "2",
          label: "主题",
        },
        {
          value: "1",
          label: "部门",
        },
        {
          value: "3",
          label: "专题",
        },
        {
          value: "4",
          label: "收藏",
        },
      ],
      itemData1: [],
      itemData2: [],
      itemData3: [],
      itemData4: [],
      servicesInput: "",
      activeIndex: 0,
      activeName: "",
      value: 5,
      dataModal: {
        show: false,
        data: {},
      },
      middlePage: JSON.parse(window.sessionStorage.getItem("setConfig"))
        .middlePage,
    };
  },
  mounted() {
    this.activeName = this.titleData[0].label;
    this.handleClick();
  },
  methods: {
    handleClick() {
      this.itemData1 = [];
      this.itemData2 = [];
      this.itemData3 = [];
      this.tableLoading = true;
      let params = {
        type: this.activeValue || "",
        keywords: this.servicesInput || "",
      };
      getTopicDlList(params).then(res => {
        this.tableLoading = false;
        let datas = res.data.data;
        if (this.activeValue != "4") {
          if (datas.length > 0) {
            this.itemData1 = datas[0].serveList.map(item => {
              return {
                ...item,
                typeName: datas[0].name,
              };
            });
          }
          if (datas.length > 1) {
            this.itemData2 = datas[1].serveList.map(item => {
              return {
                ...item,
                typeName: datas[1].name,
              };
            });
          }
          if (datas.length > 2) {
            this.itemData3 = datas[2].serveList.map(item => {
              return {
                ...item,
                typeName: datas[2].name,
              };
            });
          }
        } else {
          this.itemData4 = datas.map(item => {
            return {
              ...item,
              typeName: "收藏",
            };
          });
        }
      });
    },
    goServe(row) {
      if (row.serveType == "0" && row.queryType == "2") {
        this.dataModal.show = true;
        this.dataModal.data = row;
      }
      if (row.serveType == "0" && row.queryType == "1") {
        this.$refs.IframeView.showView(row.queryPcUrl, row.taskInstId);
      }
      if (row.serveType == "1") {
        if (!this.middlePage) {
          this.HandleApply(row);
        } else {
          let routeData = this.$router.resolve({
            path: `/ServeCenterDetail`,
            query: { id: row.serveId },
          });
          window.open(routeData.href);
        }
      }
    },
    onDialogClose() {
      this.dataModal.show = false;
    },
    HandleApply(item) {
      let processDefId = item.processDefId;
      bpmnStartProcess({ processDefId })
        .then(({ data }) => {
          if (data.code == 0) {
            window.sessionStorage.setItem(
              "processInstId",
              data.data.processInstId
            );
            this.$refs.IframeView.showView(data.data.url, data.data.taskInstId);
            // window.open(data.data.url);
          } else {
            this.$message.warning(
              data.msg || "流程系统业务忙，请刷新或者重新操作"
            );
          }
        })
        .catch(err => {
          this.$message.error("服务异常");
        });
    },
    goMore() {
      let routeData = this.$router.resolve({
        path: `/serveCenter`,
      });
      window.open(routeData.href);
    },
    onDialogClose() {
      this.dataModal.show = false;
    },
  },
  watch: {},
  filters: {},
};
</script>

<style lang="less" scoped>
.topic-dl {
  .module-items {
    padding: 10px 15px 0;
    background-color: #fff;
    .tab-draggable {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
    .centCla {
      padding: 0 0 10px 0;
      .centLf {
        padding: 5px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        position: relative;
        .lfImg {
          width: 200px;
          height: 190px;
          line-height: 190px;
          text-align: center;
          color: #fff;
          font-size: 18px;
        }
      }
    }
    .module-item {
      height: 100%;
      background-color: #f2f3f6;
      position: relative;
      cursor: move;
      > i {
        position: absolute;
        top: 10px;
        right: 10px;
        color: #1764a5;
        font-size: 23px;
        cursor: pointer;
      }
      &:hover {
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
      }
    }
    .tab-item {
      width: 128px;
      text-align: center;
      font-size: 18px;
      line-height: 38px;
      position: relative;
      cursor: pointer;
      img {
        position: absolute;
        bottom: -7px;
        left: 50%;
        margin-left: -45px;
      }
    }
    .serve-item {
      width: 200px;
      height: 190px;
      background: #f2f2f2;
      margin: 14px;
      padding-top: 15px;
      user-select: none;
      border-radius: 8px;
      cursor: pointer;
      .serve-logo {
        text-align: center;
        padding-top: 10px;
        > img {
          height: 60px;
          width: 60px;
          border-radius: 0;
        }
      }
      .serve-name {
        text-align: center;
        font-size: 18px;
        line-height: 46px;
      }
      .rateClass {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .itemTypeCla {
        position: relative;
        width: 80px;
        padding: 5px 0;
        text-align: center;
        background: #29bb9c;
        color: #fff;
      }
      .itemTypeCla:before {
        display: block;
        content: "";
        border-width: 12px 8px 12px 8px;
        border-style: solid;
        border-color: #29bb9c transparent transparent transparent;
        /* 定位 */
        position: absolute;
        left: 90%;
        top: 0;
      }
      .itemTypeCla:after {
        display: block;
        content: "";
        border-width: 12px 8px 12px 8px;
        border-style: solid;
        border-color: transparent transparent #29bb9c transparent;
        /* 定位 */
        position: absolute;
        left: 90%;
        top: 10%;
      }
    }
    .more {
      width: 100%;
      text-align: center;
      padding: 10px;
      cursor: pointer;
    }
  }
}
</style>
